module.exports = __webpack_public_path__ + "static/magnet-346a4fb87057e233be54178cbf91a555.png";